import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/svg/card-default-img.svg'


const _withScopeId = n => (_pushScopeId("data-v-430f3d32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","width":"100%","height":"100%"} }
const _hoisted_2 = { style: {"position":"absolute","left":"0","right":"0","bottom":"0","top":"0","transition":"0.1s"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "justify-center",
  style: {"background":"linear-gradient(180deg, #fff 0%, #ed6a32 100%)","border-radius":"5px"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"position":"absolute","left":"0","bottom":"0","right":"0","transition":"opacity 1s"} }
const _hoisted_8 = { style: {"display":"flex","align-items":"center","justify-content":"center","background":"linear-gradient(180deg, #fff 0%, #ed6a32 100%)","border-radius":"5px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "token",
  class: "card-image__img"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

import { computed, ref } from "vue";
import { ContentTypesEnum } from "@/utils/enum/content/contentTypesEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNotificationContentType',
  props: {
  contentType: { type: String, required: true },
  fileUrl: { type: String, required: true },
  previewUrl: { type: String, required: false, default: () => "" },
},
  setup(__props) {

const props = __props



const loading = ref(false);
const error = ref(false);
const loaded = ref(false);

const isImage = computed(
  () =>
    (props.contentType as string) === ContentTypesEnum.IMAGE ||
    (props.contentType as string) === ContentTypesEnum.GIF
);
const isVideo = computed(
  () => (props.contentType as string) === ContentTypesEnum.VIDEO
);
const isAudio = computed(
  () => (props.contentType as string) === ContentTypesEnum.AUDIO
);

return (_ctx: any,_cache: any) => {
  const _component_skeletor = _resolveComponent("skeletor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_unref(isImage))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            loading: "lazy",
            src: __props.fileUrl,
            alt: "token",
            fetchpriority: "high"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_unref(isVideo))
        ? (_openBlock(), _createElementBlock("video", {
            key: 1,
            autoplay: true,
            controls: false,
            muted: true,
            src: __props.fileUrl,
            loop: "",
            preload: "metadata",
            playsinline: "",
            onLoadeddata: _cache[0] || (_cache[0] = ($event: any) => {
            loading.value = false;
            error.value = false;
            loaded.value = true;
          }),
            onError: _cache[1] || (_cache[1] = ($event: any) => {
            loading.value = false;
            error.value = true;
            loaded.value = false;
          }),
            onLoadstart: _cache[2] || (_cache[2] = ($event: any) => {
            loading.value = true;
            error.value = false;
            loaded.value = false;
          })
          }, null, 40, _hoisted_4))
        : _createCommentVNode("", true),
      (_unref(isAudio))
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            (__props.previewUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: __props.previewUrl,
                  alt: "token"
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ], 512)), [
            [_vShow, loaded.value]
          ])
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !error.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createVNode(_component_skeletor, {
        pill: "",
        width: '100%',
        height: '100%',
        as: "div"
      })
    ], 512), [
      [_vShow, loading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_10, 512), [
      [_vShow, error.value]
    ])
  ]))
}
}

})